<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
import { mapState, mapMutations, mapActions } from 'vuex'

import __C from './primitives/_constant_'
import Loading from '@/mixins/loading.mixin'
import ServiceRoutes from '@/mixins/service.routers.mixin'

export default {
  name: 'App',
  mixins: [Loading, ServiceRoutes],
  data: () => ({
    locinfo: {},
    pagecallFuncInited: false,
    interval: 10,
    reit: null,
    time: 0,
    timer: null // timer for request history
  }),
  computed: {
    ...mapState(__C.STORE_NAMESPACE.APPLICATION, ['navDataitems', 'pagecallFunc']),
    ...mapState(__C.STORE_NAMESPACE.SYS_ENVIRONMENT, ['menuUpdated']),
  },
  watch: {
    menuUpdated() {
      this.getNavigationData().then((navItems) => {
        this.setServiceRouter(navItems)
      })
    },

    pagecallFunc(f___) {
      if (this.pagecallFuncInited || !f___) return
      this.pagecallFuncInited = true
      f___().then((() => { this.loading = false }))
    },
    $route(to, from) {
      if (!localStorage.getItem(__C.LOCAL_STORAGE_NAME.ACCOUNT)) return
      if (to.path == from.path) return

      let location = { 
        locinfo : JSON.stringify(this.locinfo),
        from    : from.path, 
        to      : to.path
      }
      this.reit = location
      this.time = 0

    },

    '$route.path'(path) {
      if (!localStorage.getItem(__C.LOCAL_STORAGE_NAME.ACCOUNT)) return
      this.putRequestHistory(this.reit)
      this.setNavState(path)
      if (this.pagecallFunc)
        setTimeout(() => {
          this.pagecallFunc().then(() => {
            this.loading = false
          })
        })

      this.closeAllFloats()

      setInterval(() => {
        this.time++
        
        let min = Math.floor(this.time / 60000)

        if (min >= this.interval) {
          let location = { 
            locinfo : JSON.stringify(this.locinfo),
            from    : this.reit.from, 
            to      : this.reit.from
          }
          this.LevedRequestHistory(location)
          this.time = 0
        }
      },10)
    },
  },
  created() {
    if (!document.getElementById('__iframe__')) {
      let iframe = document.createElement('iframe')
      iframe.id = '__iframe__'
      iframe.style.display = 'none'
      document.body.appendChild(iframe)
    }

    // ACCOUNT 정보가 없으면 로그인 페이지로 이동
    if (!localStorage.getItem(__C.LOCAL_STORAGE_NAME.ACCOUNT)) return

    this.initialize().then((navItems) => {
      this.setServiceRouter(navItems)
    })
  },
  mounted() {},
  beforeDestroy() {
    // if (this.timer) {
    //   clearInterval(this.timer)
    // }
  },
  methods: {
    ...mapActions(__C.STORE_NAMESPACE.ACCOUNT, ['putRequestHistory', 'LevedRequestHistory']),
    ...mapMutations(__C.STORE_NAMESPACE.APP_SERVICE, ['closeAllFloats']),
    ...mapMutations(__C.STORE_NAMESPACE.APPLICATION, ['setNavState']),
    ...mapActions(__C.STORE_NAMESPACE.APPLICATION, ['getNavigationData', 'initialize']),
  },
}
</script>

<!-- <style lang="stylus">
@import '~@/assets/stylus/jstyle.styl';
</style> -->

<!-- <template>
  <v-app>
    <v-main>
      <router-view/>
    </v-main>
  </v-app>
</template>

<script>

export default {
  name: 'App',

  data: () => ({
    //
  }),
}
</script> -->
